import React from "react";
import { Paper, Typography, Container, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import Header from "../../Header/Header";
import Upload from "../../Common/Upload";
import { uploadArchive } from "../../../services/FileUploadService";
import merchandiseService from "../../../services/MerchandiseService";
import { getStyles } from "./styles";

export default function ManageInventory() {
  const theme = useTheme();
  const styles = getStyles(theme);

  const handleUpload = async (file: File) => {
    const uploadResult = await uploadArchive(file, undefined, "merchandise");

    if (uploadResult) {
      const result = await merchandiseService.uploadMerchandiseCsv(file.name);
      if (result) {
        return { success: true };
      }
    }

    return {
      success: false,
      errorMessage: `Oops, something went wrong. Please make sure your CSV file contains
       all required columns and that all columns contain data.`,
    };
  };

  return (
    <>
      <Header />
      <Box sx={styles.header}>
        <Typography variant="h6" component="span">
          Manage Merchandise
        </Typography>
      </Box>
      <Container maxWidth="md">
        <Paper sx={styles.sheet}>
          <Upload fileType="csv" disabled={false} onUpload={handleUpload} />
        </Paper>
      </Container>
    </>
  );
}
